import { render, staticRenderFns } from "./OppregWorkload.vue?vue&type=template&id=35398a64&scoped=true&"
import script from "./OppregWorkload.vue?vue&type=script&lang=js&"
export * from "./OppregWorkload.vue?vue&type=script&lang=js&"
import style0 from "./OppregWorkload.vue?vue&type=style&index=0&id=35398a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35398a64",
  null
  
)

export default component.exports